<template>
  <detail-item
    icon="mdi-phone"
    name="Phone Numbers"
    :name-spacing="nameSpacing"
  >
    <q-item-label v-if="phoneList.length < 1" class="text-grey-7">
      No phone numbers to display
    </q-item-label>

    <div
      v-for="(phone, key) in phoneList"
      :key="key"
      class="q-pb-md"
    >
      <q-item-label class="text-bold">
        {{ phone.field_name }} Phone
      </q-item-label>

      <phone-number
        ref="phoneInput"
        outline
        dense
        clearable
        hide-bottom-space
        :phone="phone"
        :error="phoneHasError(key)"
        @clear="removePhone(key)"
      >
        <template #append>
          <q-btn
            icon="mdi-dots-vertical"
            class="cursor-pointer"
            round
            dense
            flat
            @click.stop
          >
            <q-tooltip>Options</q-tooltip>
            <q-popup-proxy>
              <q-card
                class="q-pa-md"
                style="width: 300px;"
              >
                <q-item-label
                  header
                  class="q-pa-none text-bold"
                >
                  Phone Type
                </q-item-label>
                <q-option-group
                  :model-value="phone.type"
                  type="radio"
                  :options="phoneTypeOptionsWithDisabled"
                  class="q-mb-sm"
                  @update:model-value="(value) => onTypeSelect(phone, value)"
                />
                <q-input
                  v-if="phone.type === 'EXTRA'"
                  v-model="phone.field_name"
                  outlined
                  class="required-astrx-container"
                  label="Phone Display Name"
                  :error="!phone.field_name"
                />

                <q-btn
                  label="Remove Phone"
                  flat
                  dense
                  no-caps
                  color="red"
                  @click="removePhone(key)"
                />
              </q-card>
            </q-popup-proxy>
          </q-btn>
        </template>
      </phone-number>
    </div>

    <q-btn
      color="teal"
      icon="mdi-plus"
      label="Add Phone"
      size="12px"
      class="q-mt-sm"
    >
      <q-menu>
        <q-card style="min-width: 150px;">
          <q-list dense>
            <q-item-label
              header
              class="text-bold q-py-sm"
            >
              Select Phone Type:
            </q-item-label>
            <q-item
              v-for="(type, key) in phoneTypeOptions"
              :key="key"
              v-close-popup
              clickable
              @click="addPhone(type.value)"
            >
              <q-item-section>{{ type.label }}</q-item-section>
            </q-item>
          </q-list>
        </q-card>
      </q-menu>
    </q-btn>
  </detail-item>
</template>

<script>
import PhoneAddressMixin from '../../../../../partials/PhoneAddressEmail'

export default {
  mixins: [PhoneAddressMixin],
  props: {
    phoneList: {
      type: Array,
      required: true
    },
    nameSpacing: {
      type: Number
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    usedOptions () {
      return this.phoneList.map(item => item.type).filter(item => item !== 'EXTRA')
    },
    phoneTypeOptions () {
      return this.phoneTypes.filter(item => !this.usedOptions.includes(item.value))
    },
    phoneTypeOptionsWithDisabled () {
      return this.phoneTypes
        .filter(item => item)
        .map(item => {
          item.disable = this.usedOptions.includes(item.value)
          return item
        })
    }
  },
  methods: {
    phoneHasError (key) {
      return !!Object.keys(this.errors).find(item => item === ('phones.' + key))
    },
    getFieldType (type) {
      const field = this.phoneTypes.find(item => item.value === type)
      return {
        type: field.value,
        field_name: field.label
      }
    },
    addPhone (type) {
      const nextPhoneType = this.getFieldType(type)
      this.phoneList.push(this.getPhonePayload(true, {
        type: nextPhoneType.type,
        field_name: nextPhoneType.field_name
      }))

      this.timed(() => {
        this.$refs.phoneInput[this.$refs.phoneInput.length - 1].focus()
      }, 100)
    },
    removePhone (key) {
      this.phoneList.splice(key, 1)
    },
    onTypeSelect (phone, value) {
      const item = this.phoneTypeOptions.find(item => item.value === value)
      phone.type = item.value
      phone.field_name = item.label
    }
  }
}
</script>
